import React, { useState, useEffect } from 'react';
import useT from '../../Traduction';

function SheetSelector({ sheetNames, onSheetsSelected }) {
  const t = useT();
  const [selectedSheets, setSelectedSheets] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  useEffect(() => {
    if (selectAll) {
      setSelectedSheets(sheetNames);
    } else {
      setSelectedSheets([]);
    }
  }, [selectAll, sheetNames]);

  const handleCheckboxChange = (sheetName) => {
    let updatedSheets;

    if (selectedSheets.includes(sheetName)) {
      // Si la checkbox est déjà sélectionnée, on la retire
      updatedSheets = selectedSheets.filter((name) => name !== sheetName);
    } else {
      // Sinon, on l'ajoute
      updatedSheets = [...selectedSheets, sheetName];
    }
    setSelectedSheets(updatedSheets);
    // Vérifier si toutes les cases sont cochées => activer "Tout"
    setSelectAll(updatedSheets.length === sheetNames.length);
  };

  const handleSelectAllChange = () => {
    if (selectAll) {
      setSelectedSheets([]);
    } else {
      setSelectedSheets(sheetNames);
    }
    setSelectAll(!selectAll);
  };

  const handleConfirm = () => {
    onSheetsSelected(selectedSheets, selectAll);
  };

  return (
    <div className="mb-3 mt-3 text-center">
      <label className="my-1 fw-bold">{t("Select_sheets")}:</label>
      <div>
        {sheetNames.length > 1 && (
          <div className="">
            <input
              type="checkbox"
              id="selectAll"
              checked={selectAll}
              onChange={handleSelectAllChange}
            />
            <label className="mx-2" htmlFor="selectAll">
              {t("All")}
            </label>
          </div>
        )}
        {sheetNames.map((sheetName) => (
          <div key={sheetName} className="">
            <input
              type="checkbox"
              id={sheetName}
              value={sheetName}
              checked={selectedSheets.includes(sheetName)}
              onChange={() => handleCheckboxChange(sheetName)}
              disabled={selectAll}
            />
            <label className="mx-2" htmlFor={sheetName}>
              {sheetName}
            </label>
          </div>
        ))}
      </div>
      {selectedSheets.length > 0 && (
        <button type="submit" className="btn mt-3" onClick={handleConfirm}>
          {t("Validate")}
        </button>
      )}
    </div>
  );
}

export default SheetSelector;